import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory("/pos-app/"),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/PosView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/create-coffee',
      name: 'create-coffee',
      component: () => import('../views/PosView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/admin',
      component: () => import('../layouts/AdminLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'admin',
          redirect: { name: 'dashboard' }
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('../views/admin/DashboardView.vue'),
          meta: { title: 'Dashboard' }
        },
        {
          path: 'customers',
          name: 'customers',
          component: () => import('../views/admin/CustomerManagementView.vue'),
          meta: { title: 'Customer Management' }
        },
        {
          path: 'staff',
          name: 'staff',
          component: () => import('../views/admin/StaffView.vue'),
          meta: { title: 'Staff Management' }
        },
        {
          path: 'staff-reports',
          name: 'staff-reports',
          component: () => import('../views/admin/StaffReportsView.vue'),
          meta: { title: 'Staff Reports' }
        },
        {
          path: 'daily-operations',
          name: 'daily-operations',
          component: () => import('../views/admin/DailyOperationsView.vue'),
          meta: { title: 'Daily Operations' }
        },
        {
          path: 'menu-items',
          name: 'menu-items',
          component: () => import('../views/admin/MenuItemManagementView.vue'),
          meta: { title: 'Menu Items' }
        },
        {
          path: 'modifiers',
          name: 'modifiers',
          component: () => import('../views/admin/ModifiersView.vue'),
          meta: { title: 'Modifiers' }
        },
        {
          path: 'menu-categories',
          name: 'menu-categories',
          component: () => import('../views/admin/MenuCategoriesView.vue'),
          meta: { title: 'Menu Categories' }
        },
        {
          path: 'inventory-items',
          name: 'inventory-items',
          component: () => import('../views/admin/InventoryItemManagementView.vue'),
          meta: { title: 'Inventory Items' }
        },
        {
          path: 'recipes',
          name: 'recipes',
          component: () => import('../views/admin/RecipeManagementView.vue'),
          meta: { title: 'Recipes' }
        },
        {
          path: 'orders',
          name: 'orders',
          component: () => import('../views/admin/OrderHistoryView.vue'),
          meta: { title: 'Order History' }
        },
        {
          path: 'consumption',
          name: 'consumption',
          component: () => import('../views/admin/ConsumptionVoucherView.vue'),
          meta: { title: 'Consumption Vouchers' }
        },
        {
          path: 'production',
          name: 'production',
          component: () => import('../views/admin/ProductionReportView.vue'),
          meta: { title: 'Production Reports' }
        },
        {
          path: 'locations',
          name: 'locations',
          component: () => import('../views/admin/WorkPointsAndLocationsView.vue'),
          meta: { title: 'Locations' }
        },
        {
          path: 'work-points',
          name: 'work-points',
          component: () => import('../views/admin/WorkPointsView.vue'),
          meta: { title: 'Work Points' }
        },
        {
          path: 'stock-locations',
          name: 'stock-locations',
          component: () => import('../views/admin/StockLocationsView.vue'),
          meta: { title: 'Stock Locations' }
        },
        {
          path: 'units-of-measure',
          name: 'units-of-measure',
          component: () => import('../views/admin/UnitOfMeasureManagementView.vue'),
          meta: { title: 'Units of Measure' }
        },
        {
          path: 'vat-rates',
          name: 'vat-rates',
          component: () => import('../views/admin/VatRatesView.vue'),
          meta: { title: 'VAT Rates' }
        },
        {
          path: 'price-lists',
          name: 'price-lists',
          component: () => import('../views/admin/PriceListManagementView.vue'),
          meta: { title: 'Price Lists' }
        },
        {
          path: 'price-matrix',
          name: 'price-matrix',
          component: () => import('../views/admin/PriceMatrixView.vue'),
          meta: { title: 'Price Matrix' }
        },
        {
          path: 'appearance',
          name: 'appearance',
          component: () => import('../views/admin/AppearanceView.vue'),
          meta: { title: 'Appearance Settings' }
        }
      ]
    }
  ]
})

// Navigation guard for authentication (placeholder)
router.beforeEach((to, from, next) => {
  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    // TODO: Implement actual authentication check
    // For now, allow all routes
    next()
  } else {
    next()
  }

  // Update page title
  if (to.meta.title) {
    document.title = `${to.meta.title} - Business Suite AI POS`
  } else {
    document.title = 'Business Suite AI - POS'
  }
})

export default router
